import { shallowEqual, useSelector } from 'react-redux'


export function useUserAsParent() {
  const parentId = useSelector((state: any) => state.user.parent?.id, shallowEqual)
  return parentId ? String(parentId) : null
}
